/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimGuaranteeCode } from './ClaimGuaranteeCode';
import {
    ClaimGuaranteeCodeFromJSON,
    ClaimGuaranteeCodeFromJSONTyped,
    ClaimGuaranteeCodeToJSON,
    ClaimGuaranteeCodeToJSONTyped,
} from './ClaimGuaranteeCode';

/**
 * 
 * @export
 * @interface ClaimCommand
 */
export interface ClaimCommand {
    /**
     * 
     * @type {string}
     * @memberof ClaimCommand
     */
    id?: string | null;
    /**
     * 
     * @type {ClaimGuaranteeCode}
     * @memberof ClaimCommand
     */
    guaranteeCode: ClaimGuaranteeCode;
    /**
     * 
     * @type {number}
     * @memberof ClaimCommand
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimCommand
     */
    deductible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimCommand
     */
    totalAmount?: number | null;
}



/**
 * Check if a given object implements the ClaimCommand interface.
 */
export function instanceOfClaimCommand(value: object): value is ClaimCommand {
    if (!('guaranteeCode' in value) || value['guaranteeCode'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ClaimCommandFromJSON(json: any): ClaimCommand {
    return ClaimCommandFromJSONTyped(json, false);
}

export function ClaimCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'guaranteeCode': ClaimGuaranteeCodeFromJSON(json['guaranteeCode']),
        'count': json['count'],
        'deductible': json['deductible'] == null ? undefined : json['deductible'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
    };
}

export function ClaimCommandToJSON(json: any): ClaimCommand {
    return ClaimCommandToJSONTyped(json, false);
}

export function ClaimCommandToJSONTyped(value?: ClaimCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'guaranteeCode': ClaimGuaranteeCodeToJSON(value['guaranteeCode']),
        'count': value['count'],
        'deductible': value['deductible'],
        'totalAmount': value['totalAmount'],
    };
}

